import { useNavigate } from "react-router-dom";
import { DashboardShell } from "../components/dashboard/DashboardKit";
import { Home, ClipboardList, Star, FileText, Phone, Camera } from "lucide-react";

const clientNav = [
  { icon: <Home className="w-5 h-5" />, label: "Dashboard",        path: "/client-dashboard"   },
  { icon: <ClipboardList className="w-5 h-5" />, label: "Project Timeline", path: "/project-timeline"   },
  { icon: <Camera className="w-5 h-5" />, label: "Visit Logs",       path: "/visit-logs"         },
  { icon: <Star className="w-5 h-5" />, label: "Feedback",         path: "/client-testimonials" },
  { icon: <FileText className="w-5 h-5" />, label: "Reports",          path: "/client-reports"      },
  { icon: <Phone className="w-5 h-5" />, label: "Contact",          path: "/contact"             },
];

const MONTSERRAT = `@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');`;

function ClientLayout({ children }) {
  const navigate = useNavigate();
  const userName = localStorage.getItem("name") || "User";

  const userInitials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <DashboardShell
      portal="Client Portal"
      roleLabel="CLIENT"
      title="Client Workspace"
      subtitle="Track your project updates, reports and discussions in one place"
      navItems={clientNav}
      user={{
        initials: userInitials,
        name:     userName,
        role:     "Client",
        onLogout: handleLogout,
      }}
  >
      <style>{MONTSERRAT + ` * { font-family: 'Montserrat', sans-serif !important; }`}</style>
      {children}
    </DashboardShell>
  );
}

export default ClientLayout;